import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context/context";
import { useState } from "react";
import { useEffect } from "react";
import Select from "react-select";
import KeepingplantsAdd from "../KeepingplantsAdd/KeepingplantsAdd";
import { CommanPlantionDetailsPartTwoDDL } from "../../../../CommonDDL/CommanPlantionDetailsPartTwoDDL";
import { CommanPlantionDetailsDDLAPI } from "../../../../../Helper/Redux/DDLSlice/DDLSlice";
import { DeadSamplingsPostAPI, PlantationDetailsPartTwoTableDataAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartTwoSlice";
import { ReplacedDeadSamplingDDL } from "../../../../CommonDDL/ReplacedDeadSamplingDDL";

const ReplacedDeadSamplingsPopUp = (props) => {

    const {YearValue,MonthValue, M_BeneficiaryDetailsID, handleShowDeadSamplingModal, Radiodeadsamplings, setRadiodeadsamplings, ShowDeadSamplingModal, ReplacedDeadSamplingsId, setReplacedDeadSamplingsId, Radiocoverlosses, setRadiocoverlosses, Title, handleIsReplacedDeadSamplingData } = props
    const { flag, data } = ShowDeadSamplingModal

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID, IndicatorGrievanceAreaID } = userDetails

    const [SamplingReceived, setSamplingReceived] = useState('')
    const [Remark, setRemark] = useState('')
    const [SubIndicatorId, setSubIndicatorId] = useState('')
    const [SufficientId, setSufficientId] = useState('')

    useEffect(() => {
        setSamplingReceived(flag == 'Update' ? data?.quantity : '')
        setRadiocoverlosses(flag == 'Update' ? data?.yesNo_M_IndicatorID : '')
    }, [data])


    const handleSubmit = () => {
        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            ReplacedDeadSaplings_M_IndicatorID: ReplacedDeadSamplingsId.ID,
            ReplacedDeadSaplingsSub_M_IndicatorID: SubIndicatorId,
            Quantity: SamplingReceived,
            IsCoverLosses_M_IndicatorID: SufficientId,
            YesNo_M_IndicatorID: Radiocoverlosses,
            Remark: Remark,
            M_TableUserMasterID: UserID,
            token: token,
            handleDataIsPost: handleIsReplacedDeadSamplingData

        }
        // console.log("RawData",KeepingQualityHomeData)s
        dispatch(DeadSamplingsPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.DeadSamplingsPostData)

    return (
        <>
            <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
                <div className="modal-dialog modal-lg " style={{ minWidth: '40vw' }} role="document"  >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title fw-bold text-danger modal-title-fs" id="exampleModalLongTitle">{Title}</h5>
                            <button onClick={() => handleShowDeadSamplingModal(false, '')} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ overflowY: 'scroll', height: '70vh' }}>
                            <div className="row">

                                <div className="col-12 col-lg-12 mx-auto pt-3">

                                    {

                                        Radiodeadsamplings == '53' ?

                                            <div className="col-8 col-lg-8 pb-3">

                                                <ReplacedDeadSamplingDDL
                                                    ReplacedDeadSamplingsId={ReplacedDeadSamplingsId}
                                                    setReplacedDeadSamplingsId={setReplacedDeadSamplingsId}
                                                    apiFlag='ReplacedDeadSaplings'
                                                    Flag={flag}
                                                    data={data}
                                                    IsPost=''
                                                />
                                            </div>
                                            :
                                            ''

                                    }


                                    {
                                        ReplacedDeadSamplingsId.ID == 58 ?
                                            <>
                                                <span>
                                                    <div className="col-12 px-3">
                                                        <input type="radio" onChange={() => setSubIndicatorId('60')} id='60' name={SubIndicatorId == 60} value="60" checked={SubIndicatorId == 60 && "checked"} />
                                                        <label for="huey"> No of sampling received</label>
                                                    </div>
                                                    {
                                                        SubIndicatorId == 60 &&
                                                        <div className="col-6 mb-2 px-3">

                                                            {/* <span>Quantity</span> */}
                                                            <input
                                                                type="text"
                                                                className="form-control mt-2  "
                                                                name="SamplingReceived"
                                                                placeholder="Quantity"
                                                                value={SamplingReceived}
                                                                onChange={(e) => setSamplingReceived(e.target.value)}


                                                            />
                                                        </div>
                                                    }

                                                    <div className="col-12 px-3">
                                                        <input type="radio" onChange={() => setSufficientId('61')} id='61' name={SufficientId == 61} value="61" checked={SufficientId == 61 && "checked"} />
                                                        <label for="dewey"> Is the number of samplings sufficient to cover losses ? </label>
                                                    </div>
                                                    {
                                                        SufficientId == 61 &&
                                                        <>
                                                            <span className="px-3">

                                                                <input type="radio" onChange={() => setRadiocoverlosses('53')} id='53' name={Radiocoverlosses == 53} value="53" checked={Radiocoverlosses == 53 && "checked"} />
                                                                <label for="huey">Yes</label>
                                                            </span>
                                                            <span>
                                                                <input type="radio" onChange={() => setRadiocoverlosses('54')} id='54' name={Radiocoverlosses == 54} value="54" checked={Radiocoverlosses == 54 && "checked"} />
                                                                <label for="dewey">No</label>
                                                            </span>

                                                        </>

                                                    }
                                                </span>
                                            </>
                                            :
                                            ''
                                    }

                                    {
                                        ReplacedDeadSamplingsId.ID == 59 ?

                                            <>
                                                <span>
                                                    <div className="col-12 px-3">
                                                        <input type="radio" onChange={() => setSubIndicatorId('60')} id='60' name={SubIndicatorId == 60} value="60" checked={SubIndicatorId == 60 && "checked"} />
                                                        <label for="huey"> No of sampling Purchased</label>
                                                    </div>
                                                    {
                                                        SubIndicatorId == 60 &&
                                                        <div className="col-6 px-3">
                                                            <input
                                                                type="text"
                                                                className="form-control mt-2 "
                                                                name="SamplingReceived"
                                                                placeholder="Quantity"
                                                                value={SamplingReceived}
                                                                onChange={(e) => setSamplingReceived(e.target.value)}
                                                            />
                                                        </div>
                                                    }

                                                    <div className="col-12 px-3 pt-2">
                                                        <input type="radio" onChange={() => setSufficientId('61')} id='61' name={SufficientId == 61} value="61" checked={SufficientId == 61 && "checked"} />
                                                        <label for="dewey"> Is the number of samplings sufficient to cover losses ? </label>
                                                    </div>

                                                    {
                                                        SufficientId == 61 &&
                                                        <>
                                                            <span className="px-3">

                                                                <input type="radio" onChange={() => setRadiocoverlosses('53')} id='53' name={Radiocoverlosses == 53} value="53" checked={Radiocoverlosses == 53 && "checked"} />
                                                                <label for="huey">Yes</label>
                                                            </span>
                                                            <span>
                                                                <input type="radio" onChange={() => setRadiocoverlosses('54')} id='54' name={Radiocoverlosses == 54} value="54" checked={Radiocoverlosses == 54 && "checked"} />
                                                                <label for="dewey">No</label>
                                                            </span>
                                                            <div className="col-6 px-3">

                                                                <input
                                                                    type="text"
                                                                    className="form-control mt-2 "
                                                                    name="Remark"
                                                                    placeholder="value"
                                                                    value={Remark}
                                                                    onChange={(e) => setRemark(e.target.value)}
                                                                />
                                                            </div>

                                                        </>

                                                    }
                                                </span>
                                            </>

                                            :
                                            ''
                                    }



                                </div>
                                <div className="col-12  d-flex justify-content-end pt-5">
                                    <div className="form-group w-80 d-flex justify-content-between">

                                        <button
                                            type='button'
                                            onClick={handleSubmit}
                                            className="btn btn-outline-dark border-2 mx-2" data-ktwizard-type="action-next">
                                            Save
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => handleShowDeadSamplingModal(false, '')}
                                            className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div >
        </>);
}

export default ReplacedDeadSamplingsPopUp;